import { useEffect } from 'react';
import { useReactDndConstructs as useDragAndDropHooks } from '../../../../dnd/ReactDndContext';
export function useDragHoverOnScrollButton(ref, acceptDropTypes, callback, delay = 500) {
  const {
    useDrop
  } = useDragAndDropHooks();
  const [{
    isOver
  }, connectDropTarget] = useDrop({
    accept: acceptDropTypes,
    canDrop: () => true,
    collect: monitor => ({
      isOver: monitor.isOver()
    }),
    drop: (_item, monitor) => {
      if (!monitor.didDrop()) {
        return {
          isBaseScrollableButtons: true
        };
      }
    }
  });
  useEffect(() => {
    let timer;
    if (isOver) {
      timer = setTimeout(() => {
        callback();
      }, delay);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isOver, delay, callback]);
  connectDropTarget(ref);
}
//# sourceMappingURL=useDragHoverOnScrollButton.js.map